const KEY = "widget_resume";
const MAX_AGE_MS = 30 * 60 * 1000;

/**
 * Where the client was when they left mid-flow to go and buy the pack that pays
 * for it: a class they were joining (`joinAfter`), or the search they were
 * picking a time from (`backTo`, a path inside the widget).
 *
 * Buying leaves the SPA for Telr's hosted page, so the intent rides in
 * sessionStorage — the only state that survives the round trip. It is
 * short-lived and single-use on purpose: a forgotten intent must never send a
 * later, unrelated purchase off to something the client has moved on from.
 */
export function saveResumeIntent({ slug, joinAfter, backTo }) {
  if (!slug || (!joinAfter && !backTo)) return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ slug, joinAfter, backTo, ts: Date.now() }));
  } catch (_err) {
    // Private mode or a full quota — the client just lands on the usual "Back to Home".
  }
}

export function peekResumeIntent() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const intent = JSON.parse(raw);
    if (!intent?.slug || (!intent?.joinAfter && !intent?.backTo)) return null;
    if (Date.now() - (intent.ts || 0) > MAX_AGE_MS) return null;
    return intent;
  } catch (_err) {
    return null;
  }
}

export function clearResumeIntent() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (_err) {
    // Nothing to do — an unreadable store is an absent intent.
  }
}
